import { render, staticRenderFns } from "./NouvelleReservation.vue?vue&type=template&id=1173a4b6"
import script from "./NouvelleReservation.vue?vue&type=script&lang=js"
export * from "./NouvelleReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports